// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { myAccountViewStyles } from "@tps/Overrides/Widgets/MyAccount/MyAccountView";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.quickLinksGridItem = { width: [12, 12, 12, 3, 3] };

myAccountViewStyles.mainSectionGridItem = { width: [12, 12, 12, 9, 9] };

myAccountViewStyles.pageTitleGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        align-items: center;
        ${xScreen("gt", "xs")} {
            ${TypographyStyle} {
                margin-bottom: 0;
            }
        }
    `,
};

myAccountViewStyles.makeDashboardMyHomePageGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        align-items: center;
    `,
};

myAccountViewStyles.accountMessagesGridItem={
    width:12,
}

myAccountViewStyles.dashboardSummaryGridItem={
    width:12,
}
